import { render } from "./DescuentoProductoModal.vue?vue&type=template&id=ca944b9c&scoped=true"
import script from "./DescuentoProductoModal.vue?vue&type=script&lang=js"
export * from "./DescuentoProductoModal.vue?vue&type=script&lang=js"

import "./DescuentoProductoModal.vue?vue&type=style&index=0&id=ca944b9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca944b9c"]])

export default __exports__